module.exports = __webpack_public_path__ + "media/assets/images/flags/mm-5a7d155298b86ec837476a7764c90917.svg";